<template>
  <div
    :class="$style.root"
    :data-has-pagination="childData?.meta?.pagination?.page < childData?.meta?.pagination?.pageCount ? '' : null"
  >
    <LayoutPageHeaderComponent
      :data="localizedData"
      :image="image?.attributes"
    />

    <ul :class="$style.list">
      <li
        :class="$style.item"
        v-for="(entry, index) in childData?.data"
      >
        <I18nLinkWithFallback
          name="france-slug"
          :localizedData="getLocalizedData(entry)?.attributes"
          :class="$style.link"
        >
          {{ getTitle(getLocalizedData(entry)?.attributes) }}
        </I18nLinkWithFallback>
      </li>
    </ul>

    <LayoutPaginationComponent
      :pagination="childData?.meta?.pagination"
      :paginateChildData="paginateChildData"
    />
  </div>
</template>

<script setup>
import { sample } from 'lodash-es'

const props = defineProps({
  pageData: Object,
  childData: {
    type: Object,
    required: false,
  },
  paginateChildData: {
    type: Function,
    required: false,
  }
})

const getLocalizedData = i18nGetLocalizedData

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data))
})

const image = computed(() => {
  const imageFromBlocks = sample(sample(props?.childData?.data?.filter(entry => entry?.attributes?.blocks?.find(i => i?.__component === 'blocks.images' && i?.images?.data?.length)))?.attributes?.blocks?.find(i => i?.__component === 'blocks.images')?.images?.data)
  return imageFromBlocks
})

const getTitle = (data) => i18nGetLocalizedTitle(data)
</script>

<style module>
.root {
  display: flex;
  flex-direction: column;
  gap: calc(var(--unit--vertical) * 3);
}

.list {
  composes: reset-list container--default from global;
}

.item:not(:last-of-type) {
  margin-bottom: calc(var(--unit--spacer) - (var(--lh) - var(--fs)) + var(--stroke--medium));
  padding-bottom: var(--unit--spacer);
  border-bottom: var(--stroke--medium) solid;
}

.link {
  composes: reset-link from global;
  display: block;
}

.link:hover,
.link:global(.router-link-exact-active) {
  color: var(--color--yellow);
}
</style>
